import { EPages } from '@microfrontends/app-shell-v2'
import { ELanguage } from '@microfrontends/react-components'
import CareerPathLandingPage from '../../components/CareerPath/Landing'
import MainLayout from '../../containers/MainLayout'
import { withTranslation } from '../../i18n'
import { ETypeNumerologyPage } from '../../services/models'
import { ICareerPathPageProps, getServerSideProps } from '../../ssr/careerPath'

export function CareerPathPage(props: ICareerPathPageProps) {
	const { isRobot = false, articles } = props
	return (
		<MainLayout
			{...props}
			metaCanonical='lo-trinh-su-nghiep'
			languageCode={ELanguage.VI}
			numerologyPage={ETypeNumerologyPage.HomeCareerPath}
			pageName={EPages.CAREER_PATH}
			metaTitle='Career Path - Tra cứu lộ trình sự nghiệp, thăng tiến | VietnamWorks'
			metaDescription='Career Path: Giúp bạn tìm thấy con đường thăng tiến trong sự nghiệp, tìm lại chính mình. Cùng VietnamWorks khám phá ngay nhé!'
			responsiveCornerColor='#005AFF'
		>
			<CareerPathLandingPage
				isRobot={isRobot}
				articles={articles}
				careerPaths={props.careerPaths}
			/>
		</MainLayout>
	)
}

export default withTranslation('home')(CareerPathPage as any)

export { getServerSideProps }
